import { toast } from '../../common_components/Toast/ToastUtils';
import XLSX from 'xlsx-js-style';
const headerStyle = {
    font: { bold: true, sz: 11, color: { rgb: '374151' } },
    fill: { fgColor: { rgb: 'E5E7EB' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const titleStyle = {
    font: { bold: true, sz: 16, color: { rgb: '181D27' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const summaryRowStyle = {
    font: { bold: true, sz: 11, color: { rgb: '181D27' } },
    fill: { fgColor: { rgb: 'F3F4F6' } },
};
// API type value -> label shown on the listing badge ("paid_media" -> "Paid Media").
const TYPE_LABELS = {
    paid_media: 'Paid Media',
    affiliate: 'Affiliate',
    'affiliate,paid_media': 'Both',
    both: 'Both',
};
const typeLabel = (type) => TYPE_LABELS[type || ''] ||
    (type || '').split(/[,_]/).filter(Boolean).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
const money = (v) => Math.round(v || 0);
const pct = (v) => `${(v || 0).toFixed(1)}%`;
// MTD % is null when there is no MTD status (past month, the 1st, no goal).
const mtdPct = (v) => (v == null ? '-' : pct(v));
const HEADERS = [
    'Account Manager', 'Type',
    'Accounts', 'New', 'Lost',
    'Mgmt Fees', 'Fees New', 'Fees Lost', 'Fees Goal', 'Fees MTD %', 'Avg MRR',
    'Commissions', 'Commissions New', 'Commissions Change %',
    'Placements',
    'Spend Actual', 'Spend Goal', 'Spend MTD %',
    'Revenue Actual', 'Revenue Goal', 'Revenue MTD %',
];
export function exportEmployeePerformance(rows, totalSummary, month) {
    if (!rows || !Array.isArray(rows) || rows.length === 0) {
        toast.info('No data available to export');
        return;
    }
    try {
        const data = rows.map((row) => [
            row.name || '',
            typeLabel(row.type),
            row.accounts?.total ?? 0,
            row.accounts?.new ?? 0,
            row.accounts?.lost ?? 0,
            money(row.management_fees?.total),
            money(row.management_fees?.new),
            money(row.management_fees?.lost),
            money(row.management_fees?.goal),
            mtdPct(row.management_fees?.mtd_goal_percent),
            money(row.management_fees?.avg_mrr),
            money(row.commissions?.total),
            money(row.commissions?.new),
            pct(row.commissions?.change_percent),
            typeof row.placements === 'object' && row.placements?.total != null ? row.placements.total : (row.placements || 'N/A'),
            money(row.spend_performance?.actual),
            money(row.spend_performance?.goal),
            mtdPct(row.spend_performance?.mtd_goal_percent),
            money(row.revenue_performance?.actual),
            money(row.revenue_performance?.goal),
            mtdPct(row.revenue_performance?.mtd_goal_percent),
        ]);
        const summaryRow = [
            'Total Summary', '',
            totalSummary?.accounts?.total ?? 0,
            totalSummary?.accounts?.new ?? 0,
            totalSummary?.accounts?.lost ?? 0,
            money(totalSummary?.management_fees?.total),
            money(totalSummary?.management_fees?.new),
            money(totalSummary?.management_fees?.lost),
            money(totalSummary?.management_fees?.goal),
            mtdPct(totalSummary?.management_fees?.mtd_goal_percent),
            money(totalSummary?.management_fees?.avg_mrr),
            money(totalSummary?.commissions?.total),
            money(totalSummary?.commissions?.new),
            pct(totalSummary?.commissions?.change_percent),
            typeof totalSummary?.placements === 'object' && totalSummary?.placements?.total != null ? (totalSummary?.placements).total : (totalSummary?.placements || 'N/A'),
            money(totalSummary?.spend_performance?.actual),
            money(totalSummary?.spend_performance?.goal),
            mtdPct(totalSummary?.spend_performance?.mtd_goal_percent),
            money(totalSummary?.revenue_performance?.actual),
            money(totalSummary?.revenue_performance?.goal),
            mtdPct(totalSummary?.revenue_performance?.mtd_goal_percent),
        ];
        const numCols = HEADERS.length;
        const titleText = `Employee Performance${month ? ` - ${month}` : ''}`;
        const titleRow = [titleText, ...Array(numCols - 1).fill('')];
        const spacerRow = Array(numCols).fill('');
        const sheetData = [titleRow, spacerRow, HEADERS, ...data, summaryRow];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        if (worksheet['A1'])
            worksheet['A1'].s = titleStyle;
        worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];
        for (let c = 0; c < numCols; c++) {
            const headerCell = XLSX.utils.encode_cell({ r: 2, c });
            if (worksheet[headerCell])
                worksheet[headerCell].s = headerStyle;
        }
        const summaryRowIndex = 3 + rows.length;
        for (let c = 0; c < numCols; c++) {
            const cellRef = XLSX.utils.encode_cell({ r: summaryRowIndex, c });
            if (worksheet[cellRef])
                worksheet[cellRef].s = summaryRowStyle;
        }
        worksheet['!cols'] = HEADERS.map((h) => ({ wch: Math.max(h.length + 2, 12) }));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Employee Performance');
        const safeMonth = month?.replace('/', '_') || 'all';
        XLSX.writeFile(workbook, `Employee_Performance_${safeMonth}.xlsx`);
    }
    catch (error) {
        console.error('Failed to export:', error);
        toast.info('Failed to export. Please try again.');
    }
}
export default exportEmployeePerformance;
